var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{attrs:{"no-gutters":""}},[_c('b-col',[_c('highcharts',{key:_vm.hcKey,ref:"sustainabiltyPieChart",attrs:{"options":_vm.chartOptions}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }